import { apiFetch } from '@/lib/api-client';
import type { CartItem } from '@/stores/cart-store';

const GUEST_TOKEN_KEY = 'dz_guest_token';

type ServerCartItem = {
  id: string;
  productId: string | null;
  kitId: string | null;
  quantity: number;
  targetUrl: string | null;
};

type ServerCartResponse = {
  cart: {
    id: string;
    guestToken: string | null;
    items: ServerCartItem[];
  };
  guestToken?: string | null;
};

function guestHeaders(): HeadersInit {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem(GUEST_TOKEN_KEY) : null;
  return token ? { 'x-guest-token': token } : {};
}

function persistGuestToken(token: string | null | undefined) {
  if (!token || typeof localStorage === 'undefined') return;
  localStorage.setItem(GUEST_TOKEN_KEY, token);
}

/**
 * Syncs the local Zustand cart into a server cart and returns the cartId
 * required by POST /checkout/orders.
 */
export async function syncLocalCartToServer(items: CartItem[], targetUrl: string): Promise<string> {
  if (items.length === 0) {
    throw new Error('Carrinho vazio');
  }

  const res = await apiFetch<ServerCartResponse>('/api/v1/cart', {
    headers: guestHeaders(),
  });
  persistGuestToken(res.guestToken ?? res.cart.guestToken);

  const cartId = res.cart.id;

  await Promise.all(
    res.cart.items.map((item) =>
      apiFetch(`/api/v1/cart/${cartId}/items/${item.id}`, { method: 'DELETE' }),
    ),
  );

  for (const item of items) {
    await apiFetch(`/api/v1/cart/${cartId}/items`, {
      method: 'POST',
      json: {
        productId: item.productId,
        quantity: item.quantity,
        targetUrl,
      },
    });
  }

  return cartId;
}
